import React, { useState } from "react";
import "./GuestLoginPage.css"; // Make sure to create this CSS file for styling
import { useNavigate } from "react-router-dom";

const GuestLogin = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("1234");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    if (email === "guest@gmail.com" && password === "1234") {
      navigate("/GuestForm")
    } else {
      setError("Invalid email or password");
    }
  };
  return (
    <div className="site-in-progress">
  <div className="overlay">
  <div className="login-container">
      <div className="login-box">
        <h2 className="text-2xl font-bold text-gray-700 mb-6">Guest Login</h2>

        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label>Email</label>
            <input type="email" placeholder="Enter your email"  value={email}  onChange={(e)=> setEmail(e.target.value)} required />
          </div>

          <div className="mb-4">
            <label>Password</label>
            <input type="password" placeholder="Enter your password"  value={password}  onChange={(e)=> setPassword(e.target.value)} required />
          </div>

          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  </div>
</div>

  );
};

export default GuestLogin;
